import React, { useState } from 'react';

const Newsletter = () => {
  const [email, setEmail] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email.trim()) {
      alert('感谢订阅！');
      setEmail('');
    }
  };

  return (
    <section className="newsletter">
      <div className="container">
        <h2>订阅更新</h2>
        <p>获取新食谱和烹饪技巧，直接发送到你的邮箱</p>
        <form className="newsletter-form" onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="输入你的邮箱"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <button type="submit">订阅</button>
        </form>
      </div>
    </section>
  );
};

export default Newsletter;
